import React from 'react'
import { useStatsigClient } from "@statsig/react-bindings/src";
import { parseJwtPayload, readJwtIdentity } from './identity'
import {
    STATSIG_USER_INFO_KEY,
    getStatsigIdentity,
} from './logEvent'

/**
 * 从当前 ZeitroA JWT 重写 statsig_user_info（与 LoginPage updateStatsigUser 一致）。
 */
export async function ensureStatsigUserFromSsoSession(client) {
    try {
        if (!client) return;
        const jwt = sessionStorage.getItem("ZeitroA");
        if (!jwt) {
            sessionStorage.removeItem(STATSIG_USER_INFO_KEY);
            return;
        }
        const payload = parseJwtPayload(jwt);
        if (!payload) {
            sessionStorage.removeItem(STATSIG_USER_INFO_KEY);
            return;
        }
        const cid =
            payload.customerid ?? payload.CustomerID ?? payload.customerId ?? "";
        if (cid === "") {
            sessionStorage.removeItem(STATSIG_USER_INFO_KEY);
            return;
        }

        const email = (payload.email || payload.Email || "").toLowerCase().trim();
        if (!email) {
            sessionStorage.removeItem(STATSIG_USER_INFO_KEY);
            console.warn(
                "@-ensureStatsigUserFromSsoSession: LO JWT missing email claim",
            );
            return;
        }

        try {
            localStorage.setItem("customerid", String(cid));
        } catch (e) {
            /* ignore */
        }

        await updateStatsigUser(client, email, String(cid));
    } catch (e) {
        console.warn("@-ensureStatsigUserFromSsoSession", e);
    }
}

/**
 * @param extras.orgName 组织显示名。切组织、选公司时传入。
 */
export const updateStatsigUser = async (client, email, customerid, extras = {}) => {
    try {
        if (!client) {
            return;
        }
        const context = client.getContext();
        const currentUser = context.user;
        const derivedFields = context?.values?.derived_fields || {};
        const jwtIdentity = readJwtIdentity();
        const stored = getStatsigIdentity();
        const identity = {
            user_id: extras.userId || jwtIdentity.user_id || stored.user_id || '',
            user_account: (email || extras.userAccount || jwtIdentity.user_account || stored.user_account || '').toLowerCase().trim(),
            customer_id: String(customerid || extras.customerId || jwtIdentity.customer_id || stored.customer_id || ''),
            org_name: extras.orgName || extras.organizationName || stored.org_name || '',
        };

        const userInfo = {
            ...currentUser,
            userID: identity.user_account,
            customIDs: {
                IP: derivedFields.ip,
                customerID: identity.customer_id,
                loid: identity.user_id,
            },
            email: identity.user_account,
            custom: {
                customerid: identity.customer_id,
                customer_id: identity.customer_id,
                user_id: identity.user_id,
                user_account: identity.user_account,
                org_name: identity.org_name,
                ip: derivedFields.ip,
                country: derivedFields.country,
                email: identity.user_account,
            }
        }
        sessionStorage.setItem(STATSIG_USER_INFO_KEY, JSON.stringify(userInfo));

        await client.updateUserAsync(userInfo);
    } catch (error) {
        console.error("statsig error", error)
    }
}

export const withStatsig = (WrappedComponent) => {
    return function WithStatsigWrapper(props) {
        const { client } = useStatsigClient();
        return <WrappedComponent {...props} statsigClient={client} />;
    };
};
